const generator = require('./clientPurchase-fullcont-multitable-generator')


export function start(detail) {

	obj[detail.act].start(detail)
}/**/

const obj = {

	add: { start: (detail) => { add(detail) } },
}

//add line
function add(detail) {
	clientPurchaseMT.forEach((mt) => {
		//console.log(mt)
		if (mt.tableName === detail.tableName) {
			//se agrego propiedad de tab para validar si se esta creando el la linea por medio del boton tab
			//si es asi pues solo has un focus
			if (detail.tab == undefined) {
				mt.add()
			} else {
				mt.add(detail.tab)
			}
		}/*if*/
	})
}

export const clientPurchaseMT = [

	{
		tableName: "purchase_vs_item",
		value: '',
		id: 'clientPurchase_form_clientPurchase_vs_item',
		html: '',
		data: [],
		dataCopy: [],
		oneRequired: false,
		fields: [
			{
				name: 'item_id',
				type: 'autocomplete',
				html: '',
				required: true,
			},

			{
				name: 'type_selling',
				type: 'autocomplete',
				html: '',
				required: true,
			},

			{
				name: 'qty',
				type: 'textfield',
				html: '',
				required: false,
			},

			{
				name: 'unit_price',
				type: 'textfield',
				html: '',
				required: false,
			},

			{
				name: 'total_price',
				type: 'textfield',
				html: '',
				required: true,
			},

		],

		generator: function (line) {
			return generator.clientPurchase_vs_item(line.id)
		},

		add: function (tab = false) {
			const newLine = generator.clientPurchase_vs_item('')
			this.html.insertAdjacentHTML("beforeend", newLine)

			const allLines = this.html.querySelectorAll('.item_id')
			const lastLine = allLines[allLines.length - 1]
			const targetInput = lastLine.querySelector('input')



			targetInput.focus()
			if (!tab) {
				targetInput.click()
			}

		}
	},

	{
		tableName: "purchase_vs_expenses",
		value: '',
		id: 'clientPurchase_form_clientPurchase_vs_expenses',
		html: '',
		data: [],
		dataCopy: [],
		oneRequired: false,
		fields: [
			{
				name: 'provider_id',
				type: 'autocomplete',
				html: '',
				required: true,
			},

			{
				name: 'expenses_account_id',
				type: 'autocomplete',
				html: '',
				required: true,
			},

			{
				name: 'date',
				type: 'textfield',
				html: '',
				required: true,
			},

			{
				name: 'amount',
				type: 'textfield',
				html: '',
				required: true,
			},
		],

		generator: function (line) {
			return generator.clientPurchase_vs_expenses(line.id)
		},

		add: function () {
			const newLine = generator.clientPurchase_vs_expenses('')
			this.html.insertAdjacentHTML("beforeend", newLine)

			const allLines = this.html.querySelectorAll('.provider_id')
			const lastLine = allLines[allLines.length - 1]
			const targetInput = lastLine.querySelector('input')
			targetInput.focus()
			targetInput.click()
		}
	},

	{
		tableName: "purchase_vs_lost",
		value: '',
		id: 'clientPurchase_form_clientPurchase_vs_lost',
		html: '',
		data: [],
		dataCopy: [],
		oneRequired: false,
		fields: [
			{
				name: 'purchase_vs_itemId',
				type: 'autocomplete',
				html: '',
				chipClick: `{"click": [{"dest":"clientPurchase", "entity":"clientPurchase", "elem":"fullcont", "act":"removeACLabel"}]}`,
				required: true,
			},

			{
				name: 'return_item',
				value: 'true',
				type: 'checkbox',
				html: '',
				required: false,
			},

			{
				name: 'lost_qty',
				type: 'textfield',
				html: '',
				required: true,
			},

			{
				name: 'lost_price',
				type: 'textfield',
				html: '',
				required: true,
			},


			{
				name: "date",
				value: '0000-00-00',
				date: true,
				html: '',
				type: 'textfield',
				required: true,
			},


			{
				name: 'notes',
				type: 'textfield',
				html: '',
				required: false,
			},

		],

		generator: function (line) {
			return generator.clientPurchase_vs_lost(line.id)
		},

		add: function () {
			const newLine = generator.clientPurchase_vs_lost('')
			this.html.insertAdjacentHTML("beforeend", newLine)

			const allLines = this.html.querySelectorAll('.line')
			const lastLine = allLines[allLines.length - 1]

			const input_item = lastLine.querySelector('.purchase_vs_itemId')
			const targetInput = input_item.querySelector('input')
			targetInput.focus()
			targetInput.click()

		}
	}

]
